import { render, staticRenderFns } from "./AboutCookiesPage.vue?vue&type=template&id=5b58f446&scoped=true&"
import script from "./AboutCookiesPage.vue?vue&type=script&lang=js&"
export * from "./AboutCookiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58f446",
  null
  
)

export default component.exports